module.exports = __webpack_public_path__ + "static/media/COS_LIFESCAN.308d9110.jpg";